import React from "react";
import { Grid, Typography, Button } from "@mui/material";
import Modal from "@instream-solutions/instream-design-system/lib/UX/Modal/Modal";

const AssetDistributionWarningWithPenaltyModal = (props) => {
  const onEditExpenseClick = () => {
    props.goToExpenseTab();
  };

  const onEditIncomeClick = () => {
    props.goToIncomeTab();
  };

  const onAssetsRankingClick = () => {
    props.goToAssetsTab();
  };

  const onDistributionPenaltyClick = () => {
    props.continueWithCalc();
  };

  return (
    <Modal
      className={"evaluate-early-distribution-modal"}
      onCancel={() => {
        props.close();
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography component={"h1"} variant={"h1"}>
            Asset Early Distribution Warning - Penalty
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography component={"p"} variant={"p"}>
            Based on the income/expense information and the asset distribution
            ranking, Plan Wizard has determined that Early Distribution of Asset
            Account(s) prior to age 59.5 of client/co-client are needed in year{" "}
            {props.distribution.earlyDistributionYear} (with Early Distribution
            penalty required). You can adjust income/expense or asset
            distribution ranking if this is not expected, or ignore the warning
            and continue with applying the penalty as a distribution.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            onClick={onEditIncomeClick}
            variant={"contained"}
            color={"primary"}
          >
            Edit Income
          </Button>
          <Button
            onClick={onEditExpenseClick}
            variant={"contained"}
            color={"primary"}
          >
            Edit Expense
          </Button>
          <Button
            onClick={onAssetsRankingClick}
            variant={"contained"}
            color={"primary"}
          >
            Edit Asset Distribution Ranking
          </Button>
          <Button
            onClick={onDistributionPenaltyClick}
            variant={"contained"}
            color={"primary"}
          >
            Ignore Warning and Apply Penalty Distribution
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

const AssetDistributionWarningWithNoPenaltyModal = (props) => {
  const onEditExpenseClick = () => {
    props.goToExpenseTab();
  };

  const onEditIncomeClick = () => {
    props.goToIncomeTab();
  };

  const onAssetsRankingClick = () => {
    props.goToAssetsTab();
  };

  const onDistributionPenaltyClick = () => {
    props.continueWithCalc();
  };

  return (
    <Modal
      className={"evaluate-early-distribution-modal"}
      onCancel={() => {
        props.close();
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography component={"h1"} variant={"h1"}>
            Asset Early Distribution Warning
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography component={"p"} variant={"p"}>
            Based on the income/expense information and the asset distribution
            ranking, Plan Wizard has determined that Asset Account distribution
            prior to client/co-client’s retirement age is needed in year{" "}
            {props.distribution.earlyNoPenaltyAssetDistributionYear} (with no
            Early Distribution penalty required). You can adjust income/expense
            or asset distribution ranking if this is not expected, or ignore the
            warning and continue to next step.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            onClick={onEditIncomeClick}
            variant={"contained"}
            color={"primary"}
          >
            Edit Income
          </Button>

          <Button
            onClick={onEditExpenseClick}
            variant={"contained"}
            color={"primary"}
          >
            Edit Expense
          </Button>
          <Button
            onClick={onAssetsRankingClick}
            variant={"contained"}
            color={"primary"}
          >
            Edit Asset Distribution Ranking
          </Button>
          <Button
            onClick={onDistributionPenaltyClick}
            variant={"contained"}
            color={"primary"}
          >
            Ignore Warning and continue
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

const AssetDistributionWarningWithBothTypesModal = (props) => {
  const onEditExpenseClick = () => {
    props.goToExpenseTab();
  };

  const onEditIncomeClick = () => {
    props.goToIncomeTab();
  };

  const onAssetsRankingClick = () => {
    props.goToAssetsTab();
  };

  const onDistributionPenaltyClick = () => {
    props.continueWithCalc();
  };

  return (
    <Modal
      className={"evaluate-early-distribution-modal"}
      onCancel={() => {
        props.close();
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography component={"h1"} variant={"h1"}>
            Multiple Asset Early Distributions Warning - Penalty
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography component={"p"} variant={"p"}>
            Based on the income/expense information and the asset distribution
            ranking, Plan Wizard has determined that multiple Asset Account
            distributions prior to age 59.5 of client/co-client are needed in
            year {props.distribution.earlyDistributionYear} (with Early
            Distribution penalty required). You can adjust income/expense or
            asset distribution ranking if this is not expected, or ignore the
            warning and continue with applying the penalty as a distribution.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            onClick={onEditIncomeClick}
            variant={"contained"}
            color={"primary"}
          >
            Edit Income
          </Button>

          <Button
            onClick={onEditExpenseClick}
            variant={"contained"}
            color={"primary"}
          >
            Edit Expense
          </Button>

          <Button
            onClick={onAssetsRankingClick}
            variant={"contained"}
            color={"primary"}
          >
            Edit Asset Distribution Ranking
          </Button>

          <Button
            onClick={onDistributionPenaltyClick}
            variant={"contained"}
            color={"primary"}
          >
            Ignore Warning and Apply Penalty Distribution
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

const AssetDistributionWarningModal = (props) => {
  if (
    props.distribution.earlyDistribution &&
    !props.distribution.earlyNoPenaltyAssetDistribution
  )
    return <AssetDistributionWarningWithPenaltyModal {...props} />;

  if (
    !props.distribution.earlyDistribution &&
    props.distribution.earlyNoPenaltyAssetDistribution
  )
    return <AssetDistributionWarningWithNoPenaltyModal {...props} />;

  if (
    props.distribution.earlyDistribution &&
    props.distribution.earlyNoPenaltyAssetDistribution
  ) {
    return <AssetDistributionWarningWithBothTypesModal {...props} />;
  }

  return <div></div>;
};

export default AssetDistributionWarningModal;
